<div class="full-height layout-row layout-align-start-center"
     (mouseenter)="isShowCopyButton=true"
     (mouseleave)="isShowCopyButton=false">

  <div class="layout-row layout-align-start-center text-ellipsis item-container"
       *ngFor="let item of viewItems; let last = last"
       [ngClass]="{'item-margin': !last}">
    <div [ngbTooltip]="item" openDelay="300" triggers="hover" container="body" class="showed-item text-ellipsis"
         [ngClass]="{'transparent': isTransparentBackground}"
         [ngStyle]="{color: color}">
      <span *ngIf="!prefix" class="br-body-2">{{ item | translate }}</span>
      <span *ngIf="prefix" class="prefix-item" translate>{{ prefix + '.' }}{{ item }}</span>
    </div>
    <app-text-copy-button *ngIf="canCopy" [text]="item" [isShowCopyBtn]="isShowCopyButton"></app-text-copy-button>
    <bringoz-button *ngIf="isAllowRemove"
                    theme="primary"
                    (onClick)="removeItem.emit(item)">
      <bringoz-icon iconName="close" fill="white"></bringoz-icon>
    </bringoz-button>
    <span *ngIf="!last" class="margin-right-5 br-body-2">,</span>
  </div>

  <div *ngIf="extraItems.length" class="margin-left-5 counter-container" [ngbTooltip]="extraItemsTooltip"
       openDelay="300" triggers="hover" container="body">
    <span>+{{ extraItems.length }}</span>
    <ng-template #extraItemsTooltip>
      <div class="layout-column">
        <span *ngFor="let extraItem of extraItems">
          <span *ngIf="!prefix">{{ extraItem | translate }}</span>
          <span *ngIf="prefix" translate>{{ prefix + '.' }}{{ extraItem }}</span>
        </span>
      </div>
    </ng-template>
  </div>
</div>
